import { render, staticRenderFns } from "./UploadClientFileForm.vue?vue&type=template&id=205a3537&scoped=true&"
import script from "./UploadClientFileForm.vue?vue&type=script&lang=js&"
export * from "./UploadClientFileForm.vue?vue&type=script&lang=js&"
import style0 from "./UploadClientFileForm.vue?vue&type=style&index=0&id=205a3537&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "205a3537",
  null
  
)

export default component.exports